import React from 'react';

import { createRoot } from 'react-dom/client';
import { SystemProviders } from '../../../providers/SystemProviders/SystemProviders';

const getConfirmationModalRoot = () => {
  const modalRootId = 'modal-root';

  const existModalRoot = document.getElementById(modalRootId);

  if (existModalRoot) {
    return existModalRoot;
  }

  const newModalRoot = document.createElement('div');
  newModalRoot.setAttribute('id', modalRootId);
  newModalRoot.setAttribute('role', 'dialog');
  newModalRoot.setAttribute('aria-modal', 'true');
  document.body.appendChild(newModalRoot);

  return newModalRoot;
};

export const openModal = (getModal: (closeModal: () => void) => React.ReactNode) => {
  const modalRoot = getConfirmationModalRoot();
  const root = createRoot(modalRoot);

  const handleCloseModal = () => {
    root.unmount();
  };

  const Modal = getModal(handleCloseModal);

  root.render(<SystemProviders>{Modal}</SystemProviders>);

  return handleCloseModal;
};
